const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const OfficeModal = require("../office/modals/OfficeModal");
const LoadingCircle = require("../core/view/LoadingCircle");
const CopyTable = require("./data/CopyTable");
const {isValidEmail} = require("../../shared/StringUtil");

const styles = require("./styles/AddModal.css");

module.exports = createReactClass({
	displayName: "UpdateModal",

	propTypes: {
		identifier: PT.oneOfType([PT.string, PT.number]),
		updateFor: PT.object,
		inputProps: PT.arrayOf(
			PT.shape({
				fieldType: PT.string.isRequired,
				placeholder: PT.string,
			})
		).isRequired,
		title: PT.string,
		subtitle: PT.string,
		onUpdate: PT.func.isRequired,
		status: PT.string,
		error: PT.string,
		onClose: PT.func,
	},

	getInitialState: function() {
		const {inputProps, updateFor} = this.props;
		const fields = _.map(inputProps, i => i.fieldType);
		const values = _.zipObject(
			fields,
			fields.map(f => "")
		);
		// Populate initial values with the original, if provided
		_.each(fields, f => {
			if (updateFor && updateFor.hasOwnProperty(f)) {
				values[f] = updateFor[f] || "";
			}
		});
		return {
			values,
			focusType: null,
			errorType: null,
		};
	},

	onUpdate: function() {
		const {values} = this.state;
		const trimmedValues = _.extend({}, values);
		const toTrim = [
			"displayName",
			"firstName",
			"lastName",
			"email",
			"schoolLogin",
			"classURL",
		];
		toTrim.forEach(field => {
			if (trimmedValues[field])
				trimmedValues[field] = _.trim(trimmedValues[field]);
		});

		if (_.every(_.omit(trimmedValues, ["classURL"]), Boolean)) {
			// BEAM URL can be set back to nothing
			const {email, emailRepeat} = values;
			if (email && emailRepeat && email !== emailRepeat) {
				this.setState({errorType: "E_EMAIL_MISMATCH"});
			} else if (email && !isValidEmail(email)) {
				this.setState({errorType: "E_INVALID_EMAIL"});
			} else {
				this.setState({errorType: null});
				this.props.onUpdate(trimmedValues);
			}
		} else {
			this.setState({errorType: "E_INVALID_INPUT"});
		}
	},

	getKeyHandler: function(f) {
		return evt => {
			if (evt.which === 13) {
				f();
			}
		};
	},

	handleChange: function(evt, field) {
		const values = _.clone(this.state.values);
		values[field] = evt.target.value;
		this.setState({values});
	},

	onInputFocus: function(fieldType) {
		this.setState({focusType: fieldType});
	},

	onInputBlur: function() {
		this.setState({focusType: null});
	},

	renderInput: function(inputProps, tabIndex, autofocus) {
		const {fieldType, placeholder} = inputProps;
		let inputClass = styles.input;
		const inputVal = this.state.values[fieldType];
		if (
			(this.state.errorType === "E_INVALID_INPUT" && !inputVal) ||
			(this.props.inputProps.length === 1 && this.props.error)
		) {
			inputClass += " " + styles.invalid;
		}
		const passwordField =
			fieldType === "password" || fieldType === "repeatPassword";
		let inputType = fieldType;
		if (passwordField) {
			// The student check prevents autofill from filling password
			inputType =
				this.state.focusType === fieldType || _.includes(placeholder, "student")
					? "text"
					: "password";
		}
		return (
			<div className={styles.inputOuter} key={"input-" + fieldType}>
				<div className={styles.inputLabel}>{placeholder}</div>
				<input
					className={inputClass}
					name={passwordField ? null : this.props.identifier + fieldType}
					type={inputType}
					autoFocus={autofocus}
					value={inputVal}
					onChange={evt => this.handleChange(evt, fieldType)}
					onKeyPress={this.getKeyHandler(this.onUpdate)}
					tabIndex={tabIndex}
					onBlur={this.onInputBlur}
					onFocus={() => this.onInputFocus(fieldType)}
				/>
			</div>
		);
	},

	render: function() {
		const {title, status, inputProps, error, updateFor} = this.props;
		const {errorType} = this.state;
		const isLoading = status === "pending";
		let errorMessage;
		if (errorType || error) {
			errorMessage = CopyTable.getErrorCopy(errorType || error);
		}
		const belowContents = (
			<div className={errorMessage ? styles.error : styles.errorHidden}>
				{errorMessage}
			</div>
		);

		let saveButton = (
			<div
				className={styles.button}
				onClick={this.onUpdate}
				tabIndex={53}
				onKeyPress={this.getKeyHandler(this.onUpdate)}
			>
				Save Changes
			</div>
		);
		const cancelButton = (
			<div
				className={styles.button}
				onClick={this.props.onClose}
				tabIndex={54}
				onKeyPress={this.getKeyHandler(this.closeModal)}
			>
				Cancel
			</div>
		);
		if (isLoading) {
			saveButton = (
				<div className={styles.loadingContainer}>
					<div className={styles.loading}>
						<LoadingCircle colorType="white" />
					</div>
				</div>
			);
		}

		const contents = inputProps.map((props, i) =>
			this.renderInput(props, i + 1, i === 0)
		);

		let subtitle = this.props.subtitle;
		if (subtitle === undefined && updateFor) {
			if (updateFor.lastName || updateFor.firstName) {
				subtitle = updateFor.lastName + ", " + updateFor.firstName;
			} else if (updateFor.displayName) {
				subtitle = updateFor.displayName;
			}
		}

		let subtitleEl;
		if (subtitle) {
			subtitleEl = (
				<div className={styles.subtitle}>
					for <b>{subtitle}</b>
				</div>
			);
		}

		return (
			<OfficeModal
				onClose={this.props.onClose}
				closeOnEsc={true}
				portalContainer={null}
				level="overBar"
				closeOnBackdropClick={false}
				modalClass={styles.fieldModal}
			>
				<div className={styles.fieldContainer}>
					<div className={styles.title}>{title}</div>
					{subtitleEl}
					{contents}
					{belowContents}
					<div className={styles.buttonRow}>
						{saveButton}
						{cancelButton}
					</div>
				</div>
			</OfficeModal>
		);
	},
});
